module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_30.81450a36.png";